import { PATH } from 'constants/RoutesConstants';
import { SOCKET_TOPIC } from 'modules/sockets/constants';
import { subscribeOnPage } from 'modules/sockets/utils.middleware';

import { PUT_GUIDELINE_SUCCESS, SELECT_GUIDELINE } from '../actionTypes';
import { getWebSocketParams } from '../selectors/ui/details';

export default function* guidelinesSockets() {
  yield subscribeOnPage(
    [PATH.GUIDELINE_DETAILED],
    SOCKET_TOPIC.DETAILS,
    getWebSocketParams as (state: unknown) => object,
    [SELECT_GUIDELINE, PUT_GUIDELINE_SUCCESS],
    undefined
  );
}
